import santa from '../../icons/santa.png';
import './Santa.css';

export default function SantaErrorPage() {
  return (
    <div className="santa-screen">
      <div className="santa-card">
        <img src={santa} alt="Santa" className="santa-icon" />
        <p className="santa-message">
          Have you been naughty or nice? Santa is still keeping some secrets and doesn't want anyone
          looking at the workshop right now! Do come back later and see how busy he has been.
        </p>
      </div>
    </div>
  );
}
